import { Component, OnInit } from '@angular/core';
import { ZWebSocket } from '../ZWebSocket';

@Component({
  selector: 'app-realtime',
  templateUrl: './realtime.component.html',
  styleUrls: ['./realtime.component.scss']
})
export class RealtimeComponent implements OnInit 
{
    // Conexão com o servidor
    private websocket: ZWebSocket = null;    

    public dataX = [0];
    public dataY = [0];
    public currentLapData = {
        speed: [],
        rpm: [],
        trottle: [],
        break: []
    };
    public bestLapData = {
        speed: [],
        rpm: [],
        throttle: [],
        brake: []
    };
    public bestLapTime = null;

    public currentLapNumber = null;
    public lastLapTime = null;
    public fastestLap = null;
    public session = null;
    public finalClassification = null;
    public participants = null;

    public weathers = { 0: 'Limpo', 1: 'Limpo com nuvens', 2: 'Nublado', 3: 'Chuva Fraca', 4: 'Chuva Forte', 5: 'Tempestade' };
    public tracks = {
        0: 'Melbourne',
        1: 'Paul Ricard',
        2: 'Shanghai',
        3: 'Sakhir (Bahrain)',
        4: 'Catalunya',
        5: 'Monaco',
        6: 'Montreal',
        7: 'Silverstone',
        8: 'Hockenheim',
        9: 'Hungaroring',
        10: 'Spa',
        11: 'Monza',
        12: 'Singapore',
        13: 'Suzuka',
        14: 'Abu Dhabi',
        15: 'Texas',
        16: 'Brazil',
        17: 'Austria',
        18: 'Sochi',
        19: 'Mexico',
        20: 'Baku (Azerbaijan)',
        21: 'Sakhir Short',
        22: 'Silverstone Short',
        23: 'Texas Short',
        24: 'Suzuka Short',
        25: 'Hanoi',
        26: 'Zandvoort'
    };

    public sessionTypes = [
        'Unknown',
        'P1',
        'P2',
        'P3',
        'Short P',
        'Q1',
        'Q2',
        'Q3',
        'Short Q',
        'OSQ',
        'R',
        'R2',
        'Time Trial',
    ];

    public nationalities = ['',
        'American', 'Argentinean', 'Australian', 'Austrian',
        'Azerbaijani', 'Bahraini', 'Belgian', 'Bolivian',
        'Brazilian', 'British', 'Bulgarian', 'Cameroonian',
        'Canadian', 'Chilean', 'Chinese', 'Colombian',
        'Costa Rican', 'Croatian', 'Cypriot', 'Czech',
        'Danish', 'Dutch', 'Ecuadorian', 'English',
        'Emirian', 'Estonian', 'Finnish', 'French',
        'German', 'Ghanaian', 'Greek', 'Guatemalan',
        'Honduran', 'Hong Konger', 'Hungarian', 'Icelander',
        'Indian', 'Indonesian', 'Irish', 'Israeli',
        'Italian', 'Jamaican', 'Japanese', 'Jordanian',
        'Kuwaiti', 'Latvian', 'Lebanese', 'Lithuanian',
        'Luxembourger', 'Malaysian', 'Maltese', 'Mexican',
        'Monegasque', 'New Zealander', 'Nicaraguan', 'North Korean',
        'Northern Irish', 'Norwegian', 'Omani', 'Pakistani',
        'Panamanian', 'Paraguayan', 'Peruvian', 'Polish',
        'Portuguese', 'Qatari', 'Romanian', 'Russian',
        'Salvadoran', 'Saudi', 'Scottish', 'Serbian',
        'Singaporean', 'Slovakian', 'Slovenian', 'South Korean',
        'South African', 'Spanish', 'Swedish', 'Swiss',
        'Thai', 'Turkish', 'Uruguayan', 'Ukrainian',
        'Venezuelan', 'Welsh',
    ];

    public obsSpeed = {
        backgroundColor: 'black',
        /*legend: 
        {
            data: ['Volta Atual', 'Melhor Volta'],
            orient: 'vertical',
            left: 15,
            textStyle: {
                fontFamily: 'f1',
                fontSize: 12
            },
            icon: 'rect',
        },*/
        grid: {
            width: '1366px',
            height: '250px',
            left: 0,
            right: 0,
            top: 0,
            bottom: 0
        },
        xAxis: [
            {
                type: 'value',
                //min: 0,
                //max: 350,
                show: false
            }
        ],
        yAxis: [
            {
                show: false,
                //min: 0,
                //max: 350,
                yAxisIndex: 0,
                position: 'right',
                axisLabel: {
                    fontFamily: 'f1'
                }
            },
            {
                show: false,
                min: 0,
                max: 10,
                yAxisIndex: 1,
                position: 'left',
                axisLabel: {
                    fontFamily: 'f1'
                }
            }  
        ],
        series: [
            {
                name: 'Volta Atual',
                data: this.currentLapData.speed,
                type: 'line',
                symbol: 'none',
                color: '#333333',
                lineStyle: {
                    width: 2
                },
            },
            {
                name: 'Melhor Volta',
                data: this.bestLapData.speed,
                type: 'line',
                symbol: 'none',
                color: 'green',
                lineStyle: {
                    width: 4,
                },
            },
        {
            name: 'Freio',
            data: this.bestLapData.brake,
            type: 'bar',
            symbol: 'none',
            color: 'red',
            lineStyle: {
                width: 2,
            },
            yAxisIndex: 1,
        },
        {
            name: 'Acelerador',
            data: this.bestLapData.throttle,
            type: 'bar',
            
            symbol: 'none',
            color: 'green',
            lineStyle: {
                width: 2,
            },
            yAxisIndex: 1
        }            
         
        ]
    }

    public obsSpeedUpdate = {};

/*
Austrália - 5027m
270	Turn 1	100m
306	Turn 1	 50m
 */

    // public chartOption = {
    //     xAxis: {
    //         type: 'value',
    //         data: this.dataX,
    //         min: 0,
    //         max: 5027
    //     },
    //     yAxis: {
    //         type: 'value',
    //     },
    //     series: [{
    //         title: 'Speed',
    //         data: this.dataY,
    //         type: 'line',
    //         markArea: {
    //             data: [ [{
    //                 name: 'T1-100m',
    //                 xAxis: 270
    //             }, {
    //                 xAxis: 306
    //             }] ]
    //         }
    //     }]
    // }

    // public chartOption = {
    //     xAxis: [
    //         {
    //             type: 'value'
    //         }
    //     ],
    //     yAxis: [
    //         {
    //             min: 0,
    //             max: 350,
    //             yAxisIndex: 0,
    //             position: 'left',
    //             axisLine: {
    //                 lineStyle: {
    //                     color: 'blue'
    //                 }
    //             },
    //         },
    //         {
    //             min: 0,
    //             max: 350,
    //             yAxisIndex: 1,
    //             position: 'left',
    //             axisLine: {
    //                 lineStyle: {
    //                     color: 'green'
    //                 }
    //             },                
    //         },
    //         {
    //             min: 0,
    //             //max: 20000,
    //             yAxisIndex: 2,
    //             xAxisIndex: 0,
    //             position: 'right',
    //             axisLine: {
    //                 lineStyle: {
    //                     color: 'yellow'
    //                 }
    //             },
    //         }
    //     ],
    //     series: [
    //         {
    //             data: this.currentLapData.speed,
    //             type: 'line',
    //             symbol: 'none',
                
    //         }, 
    //         {
    //             data: this.bestLapData.speed,
    //             type: 'line',
    //             symbol: 'none',
    //         },
    //         {
    //             data: this.currentLapData.rpm,
    //             type: 'line',
    //             symbol: 'none',
                
    //         },             
    //     ]
    // };

    public chartOption = {
        grid: {
            backgroundColor: '#000000'
        },
        xAxis: [
            {
                type: 'value',
                min: 0,
                axisLabel: {
                    fontFamily: 'f1'
                }
            }
        ],
        yAxis: [
            {
                min: 0,
                max: 350,
                yAxisIndex: 0,
                position: 'left',
                axisLabel: {
                    fontFamily: 'f1'
                }
            },
            {
                min: 0,
                max: 20000,
                yAxisIndex: 1,
                position: 'right',
                
            }
        ],
        series: [
            {
                //data: [1,50,110,220,180,56],
                data: this.currentLapData.speed,
                type: 'line',
                symbol: 'none',
                color: 'blue',
                lineStyle: {
                    width: 1
                },
            }, 
            {
                data: this.bestLapData.speed,
                type: 'line',
                symbol: 'none',
                color: 'green',
                lineStyle: {
                    width: 1
                },
            },
            {
                data: this.currentLapData.rpm,
                type: 'line',
                symbol: 'none',
                yAxisIndex: 1,
                color: 'blue',
                lineStyle: {
                    width: 1,
                    opacity: 0.8
                },
            }, 
            {
                data: this.bestLapData.rpm,
                type: 'line',
                symbol: 'none',
                yAxisIndex: 1,
                color: 'green',
                lineStyle: {
                    width: 1,
                    opacity: 0.8
                },
            },              
        ]
    }

    public graphTrackCurrentLap = [];
    public graphTrackBestLap = [];
    public graphTrackZoom = 50;

    public graphTrackOption = {
        grid:
        {
            width: '400px',
            height: '400px',
        },
        xAxis: {
            show: false,
            min: -2000, max: 2000,
            //min: point[0]-zoom, max: point[0]+zoom,
            type: 'value',
        },
        yAxis: {
            show: false,
            min: -2000, max: 2000,
            //min: point[1]-zoom, max: point[1]+zoom,
            type: 'value'
        },
        series: [
            {
                data: this.graphTrackCurrentLap,
                symbol: 'none',
                type: 'line',
                smooth: true,
                lineStyle: 
                {
                    width: 1,
                    color: 'white'
                },
                markPoint: {
                    symbol: 'circle',
                    symbolSize: 7,
                    data: [
                        {
                        name: 'coordinate',
                        coord: [0, 0]
                        }
                    ]
                },
                animation: false

            },
            {
                data: [],
                symbol: 'none',
                type: 'line',
                smooth: true,
                lineStyle: 
                {
                    width: 1,
                    color: 'green'

                },
                animation: false  
            }
        ],
        dataZoom: [
            {
                show: false,
                type: 'slider',
                xAxisIndex: 0,
                filterMode: 'none'
            },
            {
                show: false,
                type: 'slider',
                yAxisIndex: 0,
                filterMode: 'none'
            },

        ],
    };
    public graphTrackUpdate = {};

    public updateOptions = {}
    public currentData = null;
    public playerIndex = 0;

    public sessions = [];
    public newSession = false;
    public currentSessionIndex = null;

    public telemetrySession = null;
    public telemetryParticipants = [];
    public telemetrySelectedParticipant = null;
    public telemetrySelectedParticipantData = null;

    public bestLapTrack = null;
    public bestLapTyre = null;

    constructor()
    {
        /*for (let i = 0; i < 5000; i++)
        {
            this.currentLapData.speed.push([i, i % 299]),
            this.bestLapData.speed.push([i, i % 350])
        }*/


        // Instância para conexão com o servidor
        this.websocket = new ZWebSocket('ws://localhost:4401', { interval: 5000, enabled: true });

        // Evento de conexão com a WebSocket
        this.websocket.on('connected', () =>
        {
            // Log
            this.OnDebug(`Connected to server`);
        });

        // Evento de desconexão com a WebSocket
        this.websocket.on('disconnected', () =>
        {
            // Log
            this.OnDebug(`Disconnected from server.`);
        });  
        
        // Evento de recebimento de mensagem
        this.websocket.on('message', (message) =>
        {
            // Log
            //this.OnDebug(`RX: ${message}`);

            this.ParseCommand(message.command, message.data);

         //   console.log(message)

            if (message.command === 'package' && message.type === 'event')
            {
                // Nova sessão
                if (message.data.m_eventStringCode === "SSTA")
                    this.newSession = true;

                // Evento não é início nem fim de sessão?
                if (message.data.m_eventStringCode !== "SSTA" && message.data.m_eventStringCode !== "SEND")
                {
                    const sessionIndex = this.sessions.length - 1;

                    if (this.sessions[sessionIndex] !== undefined)
                    {
                        this.sessions[sessionIndex].events.push(message.data);
                    }
                }
            }            

            if (message.command === 'package' && message.type === 'session')
            {
                if (this.newSession === true)
                {
                    this.sessions.push({
                        type: this.sessionTypes[message.data.m_sessionType], 
                        track: this.tracks[message.data.m_trackId], 
                        weather: this.weathers[message.data.m_weather],
                        events: [],
                        classification: null,
                        participants: null
                    });

                    console.log(this.sessions);
                    this.newSession = false;

                }
                this.session = message.data;
            }

            if (message.command === 'package' && message.type === 'participants')
            {
                //this.participants = message.data;
                const sessionIndex = this.sessions.length - 1;

                if (this.sessions[sessionIndex] !== undefined)
                {
                    if (this.sessions[sessionIndex].participants === null)
                        this.sessions[sessionIndex].participants = message.data.m_participants;
                }                
            }

            if (message.command === 'package' && message.type === 'finalClassification')
            {
                const sessionIndex = this.sessions.length - 1;

                if (this.sessions[sessionIndex] !== undefined)
                {
                    this.sessions[sessionIndex].classification = message.data.m_classificationData;
                }
            }

            // if (message.command === 'lapData')
            // {
            //     this.m_lapDistance = message.data.m_lapDistance.toFixed(0);
            //     this.m_currentLapNum = message.data.m_currentLapNum;
            //     this.dataX.push(Number(message.data.m_lapDistance.toFixed(0)))
            // }
        
            // if (message.command === 'carTelemetry')
            // {
            //     this.speed = message.data.m_speed.toFixed(0);
            //     this.dataY.push(Number(this.speed))
            // }

            if (message.command === 'data')
            {
                this.currentData = message.data;
                /*this.m_lapDistance = message.data.lapData[0].m_lapDistance.toFixed(0);
                this.m_currentLapNum = message.data.lapData[0].m_currentLapNum;
                this.m_speed = message.data.carTelemetry[0].m_speed.toFixed(0);*/

                // Mudou de volta?
                //if (this.currentData.lapData[0].m_currentLapNum !== this.currentLapNumber)
                if (message.data.lapData[0].m_currentLapTime < this.lastLapTime)
                {
                    if (message.data.lapData[0].m_lastLapTime < this.fastestLap || this.fastestLap === null)
                    {
                        this.fastestLap = message.data.lapData[0].m_lastLapTime;
                        this.bestLapData = JSON.parse(JSON.stringify(this.currentLapData));
                    }

                    // Zera o array
                    this.currentLapData.speed = [];
                    this.currentLapData.rpm = [];

                    this.currentLapNumber = this.currentData.lapData[0].m_currentLapNum;
                }

                this.lastLapTime = message.data.lapData[0].m_currentLapTime;

                // Adiciona os dados
                if (message.data.lapData[0].m_lapDistance > 0)
                {
                    this.currentLapData.speed.push([ message.data.lapData[0].m_lapDistance, message.data.carTelemetry[0].m_speed ])
                    this.currentLapData.rpm.push([ message.data.lapData[0].m_lapDistance, message.data.carTelemetry[0].m_engineRPM ])
                }
                    

                this.updateOptions = 
                {
                    series: [
                        {
                            data: this.currentLapData.speed
                        },
                        {
                            data: this.bestLapData.speed
                        },
                        {
                            data: this.currentLapData.rpm
                        },
                        {
                            data: this.bestLapData.rpm
                        },
                    ]
                };
            }

            //console.log(this.dataX[this.dataX.length-1], this.dataY[this.dataY.length-1])



        });

        // Tenta a conexão
        this.websocket.Connect();        

    }

    public OnDebug(message)
    {
        console.log(message)
    }

    public FormatLapTime(timeInSeconds: number)
    {
        const minutes = Math.trunc(timeInSeconds / 60);
        const seconds = `${Math.trunc(timeInSeconds % 60)}`;
        const miliseconds = `${Math.trunc((timeInSeconds - Math.trunc(timeInSeconds)) * 1000)}`;

        return `${minutes},${seconds.padStart(2, '0')}.${miliseconds.padEnd(3, '0')}`;
    }

    public Stringify(data)
    {
        return JSON.stringify(data);
    }

    public ParseCommand(command, data)
    {
        if (command === 'allData')
        {
            for (const key of Object.keys(data))
                this.ParseCommand(key, data[key]);
        }
        else if (command === 'session')
            this.ParseSession(data);
        else if (command === 'participants')
            this.ParseParticipants(data);
        else if (command === 'selectedParticipant')
            this.telemetrySelectedParticipant = data;
        else if (command === 'selectedParticipantData')
        {
            // BestLap não atualizada?
            if (this.telemetrySession.track !== this.bestLapTrack || this.bestLapTyre !== data.actualTyreCompound.name)
            {
                // Solicita a BestLap
                this.websocket.Send(JSON.stringify({ command: 'getBestLap', track: this.telemetrySession.track, tyre: data.actualTyreCompound.name }));

                this.bestLapTrack = this.telemetrySession.track;
                this.bestLapTyre = data.actualTyreCompound.name;
            }

            this.telemetrySelectedParticipantData = data;

            if (this.currentLapData.speed.length > 0)
            {
                if (data.lapDistance < this.currentLapData.speed[this.currentLapData.speed.length - 1][1])
                    this.currentLapData.speed = [];
            }

            this.currentLapData.speed.push([data.lapDistance, data.speed]);


            this.obsSpeedUpdate = {
                /*xAxis: [
                    {
                        min: data.lapDistance-500,
                        max: data.lapDistance+500
                    }
                ],*/
                series: [
                    {
                        data: this.bestLapData.speed
                    },
                    {
                        data: this.currentLapData.speed
                    }                     
                ]
            }            

            this.updateOptions = 
            {
                series: [
                    {
                        data: this.currentLapData.speed
                    },
                    {
                        data: this.bestLapData.speed
                    },
                    {
                        data: this.currentLapData.rpm
                    },
                    {
                        data: this.bestLapData.rpm
                    },
                ]
            };    
            
            const x = data.worldPosition.z;
            const y = data.worldPosition.x;

            this.graphTrackCurrentLap.push([ x, y]);

            this.graphTrackUpdate = {
                /*xAxis: {
                    min: x - this.graphTrackZoom,
                    max: x + this.graphTrackZoom
                },
                yAxis: {
                    min: y - this.graphTrackZoom,
                    max: y + this.graphTrackZoom
                },*/
                dataZoom: [
                    { startValue: x - this.graphTrackZoom, endValue: x + this.graphTrackZoom},
                    { startValue: y - this.graphTrackZoom, endValue: y + this.graphTrackZoom},
                ],
                series: [
                    {
                        data: this.graphTrackCurrentLap,
                        animation: false,
                        markPoint: {
                            animation: false,
                            data: [
                                {
                                coord: [x, y]
                                }
                            ]
                        }

                    }
                ]
            }

        }
        else if (command === 'bestlap')
        {
            this.ParseBestLap(data) ;           
        }
    }

    public ParseSession(data)
    {
        this.telemetrySession = data;

        this.obsSpeedUpdate = 
        {
            xAxis: [
                {
                    min : 0,
                    max: data.trackLength
                }
            ]
        };        

        this.updateOptions = 
        {
            xAxis: [
                {
                    min : 0,
                    max: data.trackLength
                }
            ]
        };
    }

    public ParseParticipants(data)
    {
        const newParticipants = [];
//console.log(Object.keys(data))

        for (const key of Object.keys(data))
        {
            data[key].index = key;
            if (data[key].position !== 0)
            newParticipants.push(data[key]);
        }

        this.telemetryParticipants = newParticipants;
      //  console.log(newParticipants)
        //console.log(data);

    }

    public ParseBestLap(data)
    {
        this.bestLapTime = this.FormatLapTime(data.lapTime);
        this.bestLapData.speed = [];
        this.bestLapData.brake = [];
        this.bestLapData.throttle = [];
        let lastLapDistance = 0;

        const newGraphTrackBestLap = [];

        for (const record of data.lapData)
        {
            if (Math.trunc(record.lapDistance) > Math.trunc(lastLapDistance))
            {
                console.log(`${Math.trunc(record.lapDistance)} > ${Math.trunc(lastLapDistance)})`)
                this.bestLapData.speed.push([record.lapDistance, record.speed]);
                this.bestLapData.brake.push([record.lapDistance, record.brake]);
                this.bestLapData.throttle.push([record.lapDistance, record.throttle]);
                lastLapDistance = record.lapDistance;
                newGraphTrackBestLap.push([record.worldPosition.z, record.worldPosition.x])
            }               
        }

        this.graphTrackUpdate = {
            series: [
                {
                    data: this.graphTrackCurrentLap,
                },
                {
                    data: newGraphTrackBestLap
                }
            ]
        }

        this.obsSpeedUpdate = {
            series: [
                {
                    data: this.bestLapData.speed
                },
                {
                    data: this.currentLapData.speed
                },
                {
                    data: this.bestLapData.brake
                },
                {
                    data: this.bestLapData.throttle
                },    
            ]
        }            

        this.updateOptions = 
        {
            series: [
                {
                    data: this.currentLapData.speed
                },
                {
                    data: this.bestLapData.speed
                }                
            ]
        };           
    }

    public SelectParticipant(index)
    {
        this.telemetrySelectedParticipant = index;
        console.log(index)

        this.websocket.Send(JSON.stringify({ command: 'selectParticipant', index }));
    }

    public ngOnInit()
    {

    }
}

/*

mapa
const myData =
[[-186.82322692871094,304.22137451171875],[-179.93582153320312,299.79736328125],[-173.03318786621094,295.36297607421875],[-166.07098388671875,290.88958740234375],[-157.9685516357422,285.6828308105469],[-150.9521484375,281.17315673828125],[-142.76991271972656,275.9134216308594],[-135.75828552246094,271.4055480957031],[-128.68153381347656,266.8551940917969],[-120.42671966552734,261.5469970703125],[-113.33026885986328,256.9830627441406],[-106.20491027832031,252.39979553222656],[-99.05882263183594,247.80252075195312],[-90.69567108154297,242.42138671875],[-83.50849914550781,237.7963104248047],[-76.29975891113281,233.1570587158203],[-67.88882446289062,227.74365234375],[-60.62820053100586,223.06991577148438],[-52.18109130859375,217.6315155029297],[-44.87770462036133,212.92857360839844],[-40.05095672607422,209.8202667236328],[-38.82978439331055,209.0338592529297],[-31.530986785888672,204.33343505859375],[-24.1822566986084,199.60028076171875],[-15.668933868408203,194.1161346435547],[-8.328919410705566,189.38681030273438],[0.25704413652420044,183.8538055419922],[7.616401195526123,179.10951232910156],[14.998870849609375,174.34861755371094],[22.408187866210938,169.5714874267578],[31.044891357421875,164.04330444335938],[38.50015640258789,159.32444763183594],[45.983341217041016,154.62086486816406],[53.47683334350586,149.9219970703125],[60.975276947021484,145.22178649902344],[68.48889923095703,140.51116943359375],[76.00951385498047,135.77215576171875],[83.50519561767578,130.99853515625],[90.99542236328125,126.18684387207031],[98.4862289428711,121.35641479492188],[105.99481964111328,116.50929260253906],[113.50089263916016,111.66319274902344],[122.27720642089844,105.99736785888672],[129.80899047851562,101.13484191894531],[138.5714874267578,95.47734832763672],[146.12655639648438,90.59881591796875],[153.66143798828125,85.73275756835938],[161.2399444580078,80.83809661865234],[170.0354461669922,75.15589904785156],[177.60121154785156,70.26702117919922],[185.18527221679688,65.37567901611328],[194.06639099121094,59.722599029541016],[201.72164916992188,54.92311096191406],[209.40777587890625,50.140743255615234],[217.09156799316406,45.371761322021484],[224.78932189941406,40.594810485839844],[232.4867401123047,35.810977935791016],[240.18968200683594,31.019710540771484],[247.92539978027344,26.20636558532715],[256.8980712890625,20.622730255126953],[264.6214599609375,15.81644058227539],[273.6269836425781,10.20848274230957],[281.3388977050781,5.3683037757873535],[289.058349609375,0.47253701090812683],[297.998779296875,-5.240471363067627],[305.6786804199219,-10.160831451416016],[313.3664245605469,-15.091307640075684],[322.3312683105469,-20.84405517578125],[330.0204162597656,-25.778642654418945],[337.7272033691406,-30.7033748626709],[345.4640808105469,-35.60615539550781],[354.4988708496094,-41.29143142700195],[362.2443542480469,-46.15153884887695],[370.0135192871094,-51.024085998535156],[377.7709655761719,-55.89482498168945],[385.5302429199219,-60.775047302246094],[393.29840087890625,-65.66431427001953],[402.33697509765625,-71.36297607421875],[410.0900573730469,-76.26973724365234],[417.8432312011719,-81.1907730102539],[425.5828857421875,-86.1093978881836],[434.3006896972656,-91.65182495117188],[441.38134765625,-96.15389251708984],[449.1211242675781,-101.07511138916016],[455.36932373046875,-105.0478515625],[461.2809143066406,-108.80773162841797],[466.8283386230469,-112.33773040771484],[472.85211181640625,-116.1951904296875],[477.6260986328125,-119.34173583984375],[482.7379150390625,-122.945556640625],[486.7016906738281,-126.044677734375],[490.2824401855469,-129.1916961669922],[493.5224914550781,-132.42933654785156],[496.4588928222656,-135.80567932128906],[499.0469665527344,-139.23976135253906],[501.3224182128906,-142.7581024169922],[503.5701599121094,-146.9432373046875],[505.18902587890625,-150.65284729003906],[506.5210266113281,-154.4612274169922],[507.59765625,-158.4173583984375],[508.5212707519531,-163.1251220703125],[509.00042724609375,-167.26771545410156],[509.19915771484375,-171.49111938476562],[509.0493469238281,-176.47666931152344],[508.62554931640625,-180.77757263183594],[507.8796691894531,-185.06256103515625],[506.6064758300781,-190.05116271972656],[505.20123291015625,-194.2829132080078],[503.26019287109375,-199.1774444580078],[501.417236328125,-203.4210662841797],[499.47900390625,-207.78085327148438],[497.1559753417969,-213.03054809570312],[495.1652526855469,-217.6959991455078],[492.96533203125,-223.34051513671875],[491.29638671875,-228.3757781982422],[489.7279052734375,-234.4346160888672],[488.7486572265625,-239.76638793945312],[488.13165283203125,-245.23001098632812],[487.9032287597656,-251.6472930908203],[488.10504150390625,-257.2071838378906],[488.6882629394531,-262.7754821777344],[489.66241455078125,-268.36871337890625],[491.0231018066406,-273.9569091796875],[492.76239013671875,-279.48114013671875],[495.265380859375,-285.7994079589844],[497.80535888671875,-291.1264953613281],[500.7041320800781,-296.34686279296875],[503.9619140625,-301.4394836425781],[507.5655212402344,-306.3748474121094],[511.47723388671875,-311.14593505859375],[516.354736328125,-316.58563232421875],[520.69091796875,-321.2402038574219],[525.0780029296875,-325.9206848144531],[529.508056640625,-330.678955078125],[534.6492919921875,-336.3804931640625],[538.96142578125,-341.4946594238281],[543.6803588867188,-347.72113037109375],[547.4173583984375,-353.35015869140625],[550.825439453125,-359.2427978515625],[553.8870239257812,-365.3897705078125],[556.5444946289062,-371.7187805175781],[558.820068359375,-378.2538146972656],[560.972412109375,-386.0893859863281],[562.370361328125,-392.93463134765625],[563.4404296875,-400.88348388671875],[563.8807373046875,-407.65045166015625],[563.885986328125,-414.3517761230469],[563.4674682617188,-420.9727478027344],[562.6320190429688,-427.5528869628906],[561.1370239257812,-435.1852111816406],[559.4071044921875,-441.6882019042969],[556.876953125,-449.1683654785156],[554.2646484375,-455.4703063964844],[551.244384765625,-461.6283874511719],[547.2294921875,-468.6015625],[543.3749389648438,-474.3877258300781],[539.1611328125,-479.95159912109375],[534.5896606445312,-485.27587890625],[529.6741333007812,-490.3332824707031],[524.4371948242188,-495.0962219238281],[518.8922119140625,-499.55047607421875],[513.0704956054688,-503.66632080078125],[506.979248046875,-507.4625549316406],[500.6366882324219,-510.9330749511719],[494.104736328125,-514.0421752929688],[487.3809509277344,-516.7747192382812],[479.32318115234375,-519.4496459960938],[472.24920654296875,-521.3160400390625],[465.036865234375,-522.86865234375],[457.7421569824219,-524.2193603515625],[450.3992004394531,-525.4324340820312],[441.7125549316406,-526.5860595703125],[434.21942138671875,-527.205810546875],[426.6673583984375,-527.421875],[419.0862731933594,-527.277587890625],[411.4283447265625,-526.8285522460938],[402.5771484375,-525.982177734375],[394.9673156738281,-524.893798828125],[387.3791809082031,-523.3905639648438],[378.6581726074219,-521.1688842773438],[371.2163391113281,-518.926025390625],[363.8230285644531,-516.4630126953125],[356.4802551269531,-513.7431030273438],[348.0195007324219,-510.2172546386719],[340.8218994140625,-506.9742126464844],[333.6547546386719,-503.6123962402344],[325.341552734375,-499.51605224609375],[318.25225830078125,-495.83258056640625],[311.20562744140625,-492.0589599609375],[304.1388244628906,-488.2300109863281],[297.0770568847656,-484.3523864746094],[290.0451965332031,-480.3731384277344],[283.0374755859375,-476.2969055175781],[274.87493896484375,-471.4756774902344],[267.8632507324219,-467.3159484863281],[260.83697509765625,-463.1438293457031],[253.796875,-458.9629211425781],[245.56298828125,-454.0720520019531],[238.49810791015625,-449.8515930175781],[231.46142578125,-445.5451965332031],[224.49122619628906,-441.1007995605469],[217.57176208496094,-436.5492858886719],[210.66502380371094,-431.94012451171875],[203.7530059814453,-427.30926513671875],[196.8192596435547,-422.6836242675781],[189.82789611816406,-418.10650634765625],[182.78707885742188,-413.5836181640625],[175.71266174316406,-409.0877380371094],[167.43194580078125,-403.8435974121094],[160.31687927246094,-399.3402099609375],[152.01873779296875,-394.0881042480469],[145.1320037841797,-389.72894287109375],[138.631103515625,-385.5908508300781],[132.51641845703125,-381.6033020019531],[126.87370300292969,-377.7112731933594],[121.70059967041016,-373.7969665527344],[116.25619506835938,-369.1452941894531],[112.09610748291016,-365.09088134765625],[108.40132904052734,-360.9832458496094],[104.66117858886719,-356.1336669921875],[101.92455291748047,-351.97607421875],[99.59201049804688,-347.83514404296875],[97.60095977783203,-343.63446044921875],[95.98980712890625,-339.5023193359375],[94.70706939697266,-335.3746337890625],[93.7475357055664,-331.27117919921875],[93.02029418945312,-326.4715270996094],[92.73292541503906,-322.36944580078125],[92.73799896240234,-318.2125244140625],[93.1117935180664,-313.3135986328125],[93.75341033935547,-309.08355712890625],[94.69364929199219,-304.855712890625],[95.9281997680664,-300.64996337890625],[97.74772644042969,-295.80291748046875],[99.63814544677734,-291.7156066894531],[101.81727600097656,-287.7272033691406],[104.71820068359375,-283.2164001464844],[107.50908660888672,-279.4916687011719],[110.5771713256836,-275.9107971191406],[114.4745101928711,-271.9556579589844],[118.09224700927734,-268.7604064941406],[121.94158935546875,-265.7740783691406],[126.0199966430664,-263.00054931640625],[130.320556640625,-260.45941162109375],[135.55369567871094,-257.8359069824219],[140.26881408691406,-255.85873413085938],[145.92918395996094,-253.93063354492188],[150.94613647460938,-252.5870819091797],[156.957275390625,-251.39596557617188],[162.2001190185547,-250.72586059570312],[167.53135681152344,-250.38479614257812],[173.80654907226562,-250.40765380859375],[179.2412109375,-250.78855895996094],[184.69032287597656,-251.51271057128906],[191.11135864257812,-252.7239532470703],[196.68182373046875,-254.02772521972656],[202.28814697265625,-255.57485961914062],[207.90579223632812,-257.4291687011719],[213.5026397705078,-259.62957763671875],[219.9488525390625,-262.5450134277344],[225.50021362304688,-265.2638854980469],[231.08334350585938,-268.0992736816406],[237.61341857910156,-271.6036071777344],[243.1581573486328,-274.860107421875],[248.66305541992188,-278.3388671875],[255.08111572265625,-282.5820007324219],[260.6319274902344,-286.3515319824219],[267.09820556640625,-290.84503173828125],[272.6672668457031,-294.7763366699219],[278.29315185546875,-298.8265380859375],[284.8095703125,-303.6312255859375],[290.4635925292969,-307.8579406738281],[297.08343505859375,-312.815185546875],[302.8493347167969,-317.0650329589844],[308.72918701171875,-321.2743225097656],[315.6673583984375,-326.13726806640625],[321.70172119140625,-330.33258056640625],[328.7862548828125,-335.24920654296875],[334.7799987792969,-339.40679931640625],[340.52484130859375,-343.3909606933594],[346.79156494140625,-347.7366638183594],[351.82696533203125,-351.2259826660156],[357.3096923828125,-354.97039794921875],[361.7620544433594,-357.8744201660156],[366.0458984375,-360.4481201171875],[370.2061767578125,-362.6636962890625],[375.0028991699219,-364.82666015625],[379.01873779296875,-366.31304931640625],[383.6411437988281,-367.66571044921875],[387.5821533203125,-368.5266418457031],[392.0631103515625,-369.16986083984375],[395.82281494140625,-369.4317626953125],[399.4539489746094,-369.4347839355469],[403.537841796875,-369.1134033203125],[406.85650634765625,-368.56878662109375],[410.4582214355469,-367.6687927246094],[413.3556823730469,-366.6726989746094],[416.1237487792969,-365.4520263671875],[419.15643310546875,-363.783447265625],[421.52252197265625,-362.20281982421875],[424.04937744140625,-360.1531677246094],[426.0160827636719,-358.2318115234375],[427.7872314453125,-356.18170166015625],[429.5945129394531,-353.6434020996094],[430.91204833984375,-351.3647766113281],[432.1643981933594,-348.6199035644531],[433.03790283203125,-346.13873291015625],[433.7326354980469,-343.5259094238281],[434.303955078125,-340.3240661621094],[434.5762023925781,-337.4603576660156],[434.6354064941406,-334.00714111328125],[434.5724792480469,-330.92437744140625],[434.4276123046875,-327.69659423828125],[434.10589599609375,-323.81121826171875],[433.6302795410156,-320.3913269042969],[432.9590148925781,-316.9347229003906],[432.0321960449219,-312.78314208984375],[431.15020751953125,-309.1182556152344],[429.9951171875,-304.7162170410156],[428.8334045410156,-300.8863220214844],[427.5445861816406,-297.0081481933594],[425.9197692871094,-292.34307861328125],[424.40869140625,-288.2171936035156],[422.5166320800781,-283.3254089355469],[420.8158264160156,-279.0226745605469],[419.052001953125,-274.5838317871094],[416.9120788574219,-269.2386779785156],[414.9698791503906,-264.5396728515625],[412.93792724609375,-259.7489929199219],[410.8340148925781,-254.84933471679688],[408.6737060546875,-249.84634399414062],[406.4293518066406,-244.7572784423828],[403.6590270996094,-238.7328643798828],[401.1894226074219,-233.48585510253906],[398.6545715332031,-228.13711547851562],[396.0802917480469,-222.71327209472656],[393.45556640625,-217.18478393554688],[390.8006286621094,-211.59231567382812],[387.649169921875,-204.96043395996094],[384.88067626953125,-199.21395874023438],[381.9792175292969,-193.43331909179688],[378.8603210449219,-187.6867218017578],[375.4346923828125,-182.01470947265625],[371.10382080078125,-175.47528076171875],[367.25665283203125,-169.96044921875],[363.26849365234375,-164.40548706054688],[359.1096496582031,-158.87051391601562],[353.9821472167969,-152.56240844726562],[349.36553955078125,-147.24876403808594],[343.81549072265625,-141.08961486816406],[338.9572448730469,-135.8413848876953],[333.9362487792969,-130.6567840576172],[328.6998596191406,-125.63211059570312],[323.2629699707031,-120.73915100097656],[316.7684631347656,-115.116943359375],[311.1064758300781,-110.32691192626953],[305.3255310058594,-105.61537170410156],[298.3650207519531,-100.2958984375],[292.2559814453125,-95.85316467285156],[285.0322265625,-90.70935821533203],[278.7923278808594,-86.28797149658203],[272.53045654296875,-81.85418701171875],[266.39056396484375,-77.52320098876953],[260.57769775390625,-73.5040283203125],[254.14047241210938,-69.30382537841797],[248.79542541503906,-66.16692352294922],[243.5859375,-63.48405838012695],[238.50587463378906,-61.24152755737305],[233.44041442871094,-59.3723258972168],[227.57485961914062,-57.67455291748047],[222.65272521972656,-56.6492805480957],[217.06781005859375,-55.92568588256836],[212.37313842773438,-55.69778060913086],[207.7357635498047,-55.8322868347168],[203.17129516601562,-56.30513381958008],[198.71261596679688,-57.107601165771484],[193.6817626953125,-58.46998977661133],[189.47750854492188,-60.00422668457031],[185.387451171875,-61.85008239746094],[181.4007568359375,-63.999820709228516],[177.55308532714844,-66.41915893554688],[173.25808715820312,-69.57383728027344],[169.76637268066406,-72.5612564086914],[166.45794677734375,-75.79630279541016],[162.79794311523438,-79.84705352783203],[159.75401306152344,-83.50070190429688],[156.66810607910156,-87.294677734375],[152.9717254638672,-91.85842895507812],[149.72134399414062,-95.88102722167969],[146.4047393798828,-99.98470306396484],[142.9926300048828,-104.14435577392578],[139.43031311035156,-108.32181549072266],[135.65280151367188,-112.44657135009766],[131.61050415039062,-116.43623352050781],[127.27478790283203,-120.24475860595703],[122.66297149658203,-123.80902862548828],[117.7978515625,-127.09902954101562],[111.87263488769531,-130.66085815429688],[106.62761688232422,-133.5982666015625],[101.24382019042969,-136.4856719970703],[95.69845581054688,-139.29995727539062],[89.15106201171875,-142.49652099609375],[83.42454528808594,-145.24700927734375],[77.61786651611328,-147.99761962890625],[70.70404052734375,-151.14527893066406],[64.65989685058594,-153.78160095214844],[58.536075592041016,-156.39431762695312],[51.31043243408203,-159.4562225341797],[45.04999542236328,-162.1060028076172],[38.72806930541992,-164.78134155273438],[31.281343460083008,-167.93275451660156],[24.843948364257812,-170.6576385498047],[18.352277755737305,-173.40589904785156],[11.81344223022461,-176.1741180419922],[5.230844497680664,-178.96058654785156],[-2.5037622451782227,-182.235107421875],[-9.182650566101074,-185.0430450439453],[-17.071491241455078,-188.2432098388672],[-23.955535888671875,-190.8039093017578],[-30.946561813354492,-193.06591796875],[-39.14247131347656,-195.17462158203125],[-46.205810546875,-196.4905548095703],[-53.352657318115234,-197.3551025390625],[-60.56623840332031,-197.76515197753906],[-67.81732940673828,-197.72459411621094],[-75.06644439697266,-197.24244689941406],[-83.50100708007812,-196.1218719482422],[-90.68035888671875,-194.69708251953125],[-97.78705596923828,-192.85116577148438],[-104.78659057617188,-190.57260131835938],[-111.66414642333984,-187.8693389892578],[-118.37519073486328,-184.7715301513672],[-124.92291259765625,-181.27883911132812],[-132.29539489746094,-176.70315551757812],[-138.37522888183594,-172.35264587402344],[-144.1788787841797,-167.6528778076172],[-149.71910095214844,-162.5934295654297],[-155.7998809814453,-156.30162048339844],[-160.70140075683594,-150.58578491210938],[-165.27090454101562,-144.57656860351562],[-170.1457061767578,-137.21966552734375],[-173.9276580810547,-130.6503448486328],[-177.3496856689453,-123.87374114990234],[-180.47540283203125,-116.91150665283203],[-183.8280487060547,-108.61295318603516],[-186.1506805419922,-102.65066528320312],[-189.5287628173828,-94.24889373779297],[-192.50616455078125,-87.07070922851562],[-195.52877807617188,-79.867431640625],[-198.5950164794922,-72.64840698242188],[-202.28347778320312,-64.20490264892578],[-205.52157592773438,-56.95187759399414],[-208.8188934326172,-49.67365264892578],[-212.7656707763672,-41.18790817260742],[-216.23789978027344,-33.883785247802734],[-219.73326110839844,-26.602102279663086],[-223.8798370361328,-18.062135696411133],[-226.88536071777344,-11.945560455322266],[-227.49574279785156,-10.709402084350586],[-231.73707580566406,-2.149754762649536],[-235.39532470703125,5.2157111167907715],[-239.0723114013672,12.61523151397705],[-243.3773193359375,21.27703857421875],[-247.08340454101562,28.73313331604004],[-250.8115997314453,36.23414993286133],[-255.1533203125,44.96938705444336],[-258.8943176269531,52.49800109863281],[-262.63671875,60.085548400878906],[-266.9541015625,68.95050811767578],[-270.6402587890625,76.58435821533203],[-274.3405456542969,84.26597595214844],[-278.04241943359375,91.95514678955078],[-281.7525939941406,99.6610336303711],[-285.4851989746094,107.41331481933594],[-289.8486633300781,116.47855377197266],[-292.94482421875,122.91903686523438],[-297.29119873046875,132.00738525390625],[-300.9766540527344,139.86410522460938],[-304.5999755859375,147.7382354736328],[-308.7998352050781,156.9709014892578],[-312.4023742675781,164.91812133789062],[-316.0162658691406,172.8946990966797],[-319.62713623046875,180.8643798828125],[-323.8367919921875,190.1608123779297],[-327.4603576660156,198.14450073242188],[-331.57867431640625,207.12930297851562],[-334.94256591796875,214.40740966796875],[-338.60589599609375,222.3082733154297],[-341.57342529296875,228.70376586914062],[-344.8099060058594,235.67796325683594],[-347.412109375,241.28729248046875],[-350.22174072265625,247.34738159179688],[-352.49053955078125,252.24322509765625],[-354.7019348144531,257.0160827636719],[-357.0809020996094,262.14990234375],[-358.98004150390625,266.2484436035156],[-360.75750732421875,270.0531005859375],[-362.7330322265625,274.11138916015625],[-364.44964599609375,277.3351135253906],[-366.53155517578125,280.7303771972656],[-368.4039306640625,283.35284423828125],[-370.3384704589844,285.7014465332031],[-372.33636474609375,287.793701171875],[-374.3673400878906,289.59527587890625],[-376.434326171875,291.1504821777344],[-378.837158203125,292.6497802734375],[-380.89501953125,293.6868591308594],[-383.3412780761719,294.6188659667969],[-385.46978759765625,295.19268798828125],[-387.607177734375,295.559814453125],[-390.0827941894531,295.7293701171875],[-392.2243347167969,295.6676330566406],[-394.40972900390625,295.4174499511719],[-396.6304626464844,294.9691162109375],[-398.8693542480469,294.3169860839844],[-401.1048583984375,293.4609375],[-403.3333435058594,292.3963623046875],[-405.5282287597656,291.1195068359375],[-407.6727294921875,289.6387634277344],[-410.0843811035156,287.6509094238281],[-412.0469970703125,285.7334289550781],[-414.18597412109375,283.2561950683594],[-415.8720703125,280.937744140625],[-417.4823913574219,278.4637451171875],[-419.2630920410156,275.37457275390625],[-420.6866455078125,272.5552062988281],[-422.1716003417969,269.0838928222656],[-423.2681579589844,265.9523010253906],[-424.2802429199219,262.6964111328125],[-425.3852233886719,258.73193359375],[-426.2423095703125,255.21163940429688],[-427.0390319824219,251.62713623046875],[-427.8190612792969,247.93667602539062],[-428.73486328125,243.51956176757812],[-429.5426330566406,239.60153198242188],[-430.3821716308594,235.52284240722656],[-431.2539978027344,231.2845916748047],[-432.148193359375,226.93389892578125],[-433.04681396484375,222.49533081054688],[-433.9131164550781,217.9243927001953],[-434.6778259277344,213.19627380371094],[-435.32525634765625,207.48464965820312],[-435.59246826171875,202.4451904296875],[-435.50567626953125,196.525634765625],[-435.0758361816406,191.4060516357422],[-434.2915344238281,186.27468872070312],[-433.1158447265625,181.1256561279297],[-431.5645446777344,176.0312957763672],[-429.6861267089844,171.04136657714844],[-427.1422424316406,165.37474060058594],[-424.7502136230469,160.62229919433594],[-422.05853271484375,156.0457763671875],[-419.09619140625,151.6594696044922],[-415.3050842285156,146.82586669921875],[-411.7802734375,142.94564819335938],[-408.0811462402344,139.3505401611328],[-404.4363708496094,136.06671142578125],[-400.39544677734375,132.49014282226562],[-397.16534423828125,129.4198455810547],[-394.1495361328125,126.31351470947266],[-391.2976379394531,123.16504669189453],[-388.33477783203125,119.48045349121094],[-385.96978759765625,116.35845947265625],[-383.4495849609375,112.77582550048828],[-383.1148376464844,112.27455139160156],[-380.8962707519531,108.78014373779297],[-379.1595764160156,105.85018157958984],[-377.60528564453125,102.99697875976562],[-376.2187805175781,100.21762084960938],[-525.44091796875,89.12567138671875],[-529.0639038085938,93.64922332763672],[-532.7186279296875,98.23347473144531],[-536.4401245117188,102.8916015625],[-540.2064208984375,107.64212036132812],[-544.0010375976562,112.47685241699219],[-547.8368530273438,117.38797760009766],[-551.7306518554688,122.37305450439453],[-555.66845703125,127.40330505371094],[-559.6613159179688,132.49349975585938],[-563.697265625,137.64743041992188],[-568.1860961914062,143.41842651367188],[-571.7947387695312,148.12371826171875],[-575.111328125,152.59352111816406],[-578.1295776367188,156.8825225830078],[-581.2193603515625,161.72329711914062],[-583.5130615234375,165.77272033691406],[-585.48583984375,169.748046875],[-587.1505737304688,173.63490295410156],[-588.5142822265625,177.4493865966797],[-589.6080932617188,181.2434539794922],[-590.3991088867188,185.04861450195312],[-590.9037475585938,188.86268615722656],[-591.1683349609375,193.30101013183594],[-591.166015625,197.07730102539062],[-590.9246215820312,200.82618713378906],[-590.2994995117188,205.15855407714844],[-589.5209350585938,208.78639221191406],[-588.3104858398438,212.89198303222656],[-587.0140991210938,216.32504272460938],[-585.2010498046875,220.2338104248047],[-583.3826904296875,223.52297973632812],[-581.3133544921875,226.75888061523438],[-578.5852661132812,230.43675231933594],[-575.9619750976562,233.48486328125],[-573.1161499023438,236.46461486816406],[-570.0568237304688,239.4188995361328],[-566.2614135742188,242.92686462402344],[-562.87353515625,246.01876831054688],[-559.3910522460938,249.21107482910156],[-555.8310546875,252.4917755126953],[-551.7078247070312,256.36346435546875],[-548.197021484375,259.6893310546875],[-544.905029296875,262.91845703125],[-541.4541015625,266.6329345703125],[-538.8423461914062,269.7586364746094],[-536.555419921875,272.7977600097656],[-534.2630004882812,276.2731018066406],[-532.5916748046875,279.1837158203125],[-530.9677124023438,282.50238037109375],[-529.8589477539062,285.2557373046875],[-528.89404296875,288.3692626953125],[-528.336181640625,290.9544372558594],[-528.0157470703125,293.46685791015625],[-527.9219970703125,296.3271179199219],[-528.0723266601562,298.70928955078125],[-528.4277954101562,301.01531982421875],[-528.9315795898438,303.2742614746094],[-529.7410888671875,305.8462829589844],[-530.619873046875,308.0014953613281],[-531.69189453125,310.1246337890625],[-532.9520263671875,312.23394775390625],[-534.3265380859375,314.3977355957031],[-535.8027954101562,316.67108154296875],[-537.5726318359375,319.51025390625],[-539.0529174804688,322.14642333984375],[-540.4418334960938,324.98480224609375],[-541.6884765625,328.00482177734375],[-542.6923828125,331.08489990234375],[-543.4256591796875,334.1755676269531],[-543.9257202148438,337.2912902832031],[-544.1937255859375,340.96148681640625],[-544.1688232421875,344.1545715332031],[-543.9414672851562,347.3999938964844],[-543.37548828125,351.21478271484375],[-542.6213989257812,354.5199279785156],[-541.617431640625,357.822509765625],[-540.1251220703125,361.6502685546875],[-538.57275390625,364.9078063964844],[-536.7853393554688,368.16094970703125],[-534.447265625,371.9745178222656],[-532.2496337890625,375.3125],[-529.9293823242188,378.7200927734375],[-527.0751953125,382.7906494140625],[-524.5385131835938,386.3592224121094],[-521.4991455078125,390.6085510253906],[-518.8003540039062,394.3221740722656],[-515.4947509765625,398.769775390625],[-513.0243530273438,402.0565185546875],[-509.4740295410156,406.6928405761719],[-506.2240295410156,410.741943359375],[-502.7608337402344,414.7353820800781],[-498.407958984375,419.2325134277344],[-494.38934326171875,422.880615234375],[-490.097412109375,426.310546875],[-484.78375244140625,429.9747619628906],[-479.94366455078125,432.8506774902344],[-474.8663330078125,435.45343017578125],[-469.5466613769531,437.764892578125],[-464.01416015625,439.76385498046875],[-458.29034423828125,441.4353942871094],[-451.3946228027344,442.94305419921875],[-445.32904052734375,443.8359069824219],[-438.1302490234375,444.38922119140625],[-431.8702697753906,444.4333801269531],[-425.55133056640625,444.0664978027344],[-418.15338134765625,443.114501953125],[-411.8046875,441.8635559082031],[-404.38861083984375,440.0280456542969],[-398.0117492675781,438.2466735839844],[-391.6050720214844,436.2792053222656],[-384.1626892089844,433.6355895996094],[-377.86279296875,430.98773193359375],[-370.6143798828125,427.5058898925781],[-364.461669921875,424.2512512207031],[-358.34478759765625,420.788330078125],[-351.2487487792969,416.53875732421875],[-345.16705322265625,412.7645263671875],[-338.0953369140625,408.2530822753906],[-332.0089111328125,404.30255126953125],[-325.90185546875,400.274169921875],[-318.79022216796875,395.4563903808594],[-312.674072265625,391.23779296875],[-306.5472106933594,386.9848937988281],[-300.3537292480469,382.693603515625],[-293.05987548828125,377.72119140625],[-286.7502136230469,373.48199462890625],[-280.3720397949219,369.22283935546875],[-273.9449157714844,364.93743896484375],[-267.4932861328125,360.6361999511719],[-260.9770202636719,356.29168701171875],[-254.42523193359375,351.9239807128906],[-247.86068725585938,347.5486755371094],[-240.1679229736328,342.44805908203125],[-233.48048400878906,338.10125732421875],[-226.72293090820312,333.7899169921875],[-219.9117431640625,329.49310302734375],[-213.0572052001953,325.18865966796875],[-206.17471313476562,320.87213134765625],[-199.26654052734375,316.5401916503906],[-191.18313598632812,311.4708251953125],[-184.22494506835938,307.1070861816406],[-177.2332305908203,302.7231750488281],[-170.21873474121094,298.32525634765625],[-161.99664306640625,293.1589660644531],[-154.98446655273438,288.70135498046875],[-147.9535369873047,284.1788635253906],[-140.9038543701172,279.61358642578125],[-132.6680145263672,274.2669982910156],[-126.77621459960938,270.43927001953125],[-118.49584197998047,265.057861328125],[-111.3636703491211,260.42120361328125],[-104.22846221923828,255.7803192138672],[-97.06403350830078,251.11837768554688],[-88.67768859863281,245.65936279296875],[-81.52291107177734,241.00071716308594],[-74.31873321533203,236.30897521972656],[-67.09722137451172,231.6051788330078],[-59.85700988769531,226.8896026611328],[-52.60804748535156,222.16856384277344],[-45.32826232910156,217.42709350585938],[-38.05033874511719,212.68634033203125],[-30.75265121459961,207.9322052001953],[-22.229915618896484,202.37904357910156],[-16.129899978637695,198.4036102294922],[-8.78110122680664,193.61886596679688],[-0.1835293173789978,188.0399932861328],[5.971393585205078,184.0569610595703],[14.564132690429688,178.50079345703125],[21.976116180419922,173.70916748046875],[30.636159896850586,168.11097717285156],[38.04248809814453,163.32321166992188],[45.470760345458984,158.521240234375],[52.938392639160156,153.6929168701172],[60.38884735107422,148.87435913085938],[67.84706115722656,144.0494842529297],[76.5866470336914,138.3956756591797],[84.0568618774414,133.58201599121094],[92.79619598388672,127.97737884521484],[100.32595825195312,123.16260528564453],[107.86216735839844,118.34777069091797],[116.66716766357422,112.72421264648438],[124.21791076660156,107.90206909179688],[131.78265380859375,103.07064056396484],[139.34796142578125,98.2383804321289],[148.18885803222656,92.59056091308594],[155.7679443359375,87.7480697631836],[164.62973022460938,82.08544158935547],[170.96849060058594,78.03475189208984],[178.56314086914062,73.1807861328125],[186.192626953125,68.3036880493164],[193.80801391601562,63.434837341308594],[202.6824951171875,57.760860443115234],[210.30775451660156,52.88480758666992],[219.21539306640625,47.188594818115234],[226.8548583984375,42.3028450012207],[234.501953125,37.411380767822266],[242.1550750732422,32.51530456542969],[249.82872009277344,27.60548210144043],[258.7486572265625,21.897890090942383],[266.4210205078125,16.988296508789062],[274.11529541015625,12.063928604125977],[283.05181884765625,6.344455242156982],[290.73590087890625,1.425921082496643],[298.4136657714844,-3.48922061920166],[306.11279296875,-8.418672561645508],[315.08441162109375,-14.163674354553223],[322.78021240234375,-19.091411590576172],[330.4927062988281,-24.030664443969727],[339.4781494140625,-29.78537368774414],[347.1929016113281,-34.72629928588867],[354.9045715332031,-39.665645599365234],[362.6293640136719,-44.61380386352539],[370.33905029296875,-49.55235290527344],[378.06243896484375,-54.49930953979492],[385.78802490234375,-59.447994232177734],[394.8039245605469,-65.22402954101562],[402.5402526855469,-70.18086242675781],[411.5519714355469,-75.95429992675781],[419.3052062988281,-80.92214965820312],[428.31573486328125,-86.69664001464844],[435.9360046386719,-91.57984161376953],[444.28607177734375,-96.93150329589844],[451.0514831542969,-101.27067565917969],[457.4350280761719,-105.36648559570312],[464.4410400390625,-109.87751007080078],[470.0347595214844,-113.54528045654297],[476.0343017578125,-117.68608093261719],[480.71661376953125,-121.22676086425781],[484.96728515625,-124.81339263916016],[489.43975830078125,-129.10047912597656],[492.8319396972656,-132.83485412597656],[495.857177734375,-136.66127014160156],[498.53399658203125,-140.5679168701172],[500.8620910644531,-144.5215606689453],[502.8428649902344,-148.53126525878906],[504.76922607421875,-153.25108337402344],[506.0939636230469,-157.3845672607422],[507.3074645996094,-162.15858459472656],[508.10711669921875,-166.25692749023438],[508.6539306640625,-170.31915283203125],[508.9262390136719,-175.10171508789062],[508.84674072265625,-179.2543182373047],[508.4172668457031,-184.10691833496094],[507.7203674316406,-188.27841186523438],[506.7417907714844,-192.4493408203125],[505.2484436035156,-197.26870727539062],[503.6581115722656,-201.33743286132812],[501.8089904785156,-205.31341552734375],[500.8211975097656,-207.25927734375],[500.486328125,-207.89723205566406],[498.4217529296875,-211.7006072998047],[496.3522644042969,-215.43482971191406],[494.2973327636719,-219.1347198486328],[492.26751708984375,-222.79270935058594],[490.26251220703125,-226.41432189941406],[-529.048828125,93.65372467041016],[-532.64208984375,98.29271697998047],[-536.2561645507812,103.04129028320312],[-539.9176635742188,107.87804412841797],[-544.2669067382812,113.60205841064453],[-548.0907592773438,118.55050659179688],[-552.0043334960938,123.54014587402344],[-555.9862670898438,128.5804901123047],[-560.0166625976562,133.6710205078125],[-564.0820922851562,138.8021697998047],[-567.959228515625,143.7056884765625],[-571.5941162109375,148.35328674316406],[-574.94384765625,152.77879333496094],[-578.5082397460938,157.71168518066406],[-581.1978759765625,161.8101043701172],[-583.8983154296875,166.49176025390625],[-585.84375,170.4407958984375],[-587.46630859375,174.30862426757812],[-588.9819946289062,178.75286865234375],[-589.97265625,182.55487060546875],[-590.65966796875,186.36151123046875],[-591.0648803710938,190.17514038085938],[-591.2301635742188,194.60540771484375],[-591.1458129882812,198.36878967285156],[-590.7046508789062,202.72921752929688],[-590.05224609375,206.4300994873047],[-589.0000610351562,210.63758850097656],[-588.0515747070312,213.5640411376953],[-586.6922607421875,217.01744079589844],[-585.0916137695312,220.39971923828125],[-583.2468872070312,223.72096252441406],[-581.1443481445312,226.99205017089844],[-578.3926391601562,230.68948364257812],[-575.7384643554688,233.76271057128906],[-572.8565673828125,236.74693298339844],[-569.7601928710938,239.68466186523438],[-565.909423828125,243.1531219482422],[-563.0391845703125,245.68650817871094],[-559.5132446289062,248.82542419433594],[-555.9326171875,252.0543670654297],[-552.3662109375,255.34234619140625],[-548.2822265625,259.2654113769531],[-545.0166015625,262.6092529296875],[-542.0759887695312,265.854736328125],[-539.4409790039062,269.01568603515625],[-536.7311401367188,272.58380126953125],[-534.7239379882812,275.55816650390625],[-532.9827880859375,278.4783020019531],[-531.50048828125,281.3419189453125],[-530.2776489257812,284.1321105957031],[-529.3165893554688,286.84332275390625],[-528.519287109375,289.9064636230469],[-528.0989379882812,292.4433898925781],[-527.9063110351562,294.9145202636719],[-527.9315795898438,297.3326416015625],[-528.2256469726562,300.05157470703125],[-528.6614379882812,302.3189697265625],[-529.281005859375,304.53533935546875],[-530.2014770507812,307.0621643066406],[-531.1839599609375,309.17706298828125],[-532.377197265625,311.25689697265625],[-533.701904296875,313.37493896484375],[-535.3820190429688,315.9629211425781],[-536.8897705078125,318.32806396484375],[-538.6290283203125,321.3163757324219],[-540.04052734375,324.0848388671875],[-541.3302001953125,327.05255126953125],[-542.4126586914062,330.1405944824219],[-543.2279663085938,333.2364501953125],[-543.792236328125,336.3514709472656],[-544.11572265625,339.4938659667969],[-544.19580078125,342.6685485839844],[-544.0155639648438,346.4266357421875],[-543.6142578125,349.6719055175781],[-542.9668579101562,352.9424743652344],[-542.066650390625,356.2307434082031],[-540.9144897460938,359.5196228027344],[-539.5188598632812,362.7843322753906],[-537.8803100585938,366.05548095703125],[-535.7085571289062,369.8750305175781],[-533.63525390625,373.1802978515625],[-531.3963012695312,376.568115234375],[-528.6240234375,380.59942626953125],[-526.1101684570312,384.158935546875],[-523.5407104492188,387.76251220703125],[-520.9019775390625,391.4374694824219],[-517.70458984375,395.7919921875],[-514.7689819335938,399.5830993652344],[-511.60223388671875,403.3545837402344],[-508.18096923828125,407.0720520019531],[-504.52899169921875,410.7536926269531],[-500.6764831542969,414.3984680175781],[-495.9014892578125,418.54742431640625],[-491.52386474609375,421.9351806640625],[-486.8692626953125,425.11151123046875],[-481.1294860839844,428.4814147949219],[-475.9830017089844,431.0580749511719],[-469.7340087890625,433.7798767089844],[-464.177001953125,435.9284973144531],[-458.4601745605469,437.874755859375],[-452.5534362792969,439.5342102050781],[-445.4947814941406,440.9877014160156],[-439.2991638183594,441.8138732910156],[-431.9246520996094,442.2555236816406],[-426.6164855957031,442.2165832519531],[-419.1283874511719,441.67047119140625],[-412.6792907714844,440.75604248046875],[-406.2264099121094,439.5098571777344],[-399.73095703125,438.01611328125],[-392.1446838378906,436.0087890625],[-385.6650390625,433.97869873046875],[-379.250244140625,431.5762939453125],[-372.9366149902344,428.7716979980469],[-365.76373291015625,425.02423095703125],[-359.7303161621094,421.46826171875],[-353.7463073730469,417.70556640625],[-347.7607116699219,413.8305969238281],[-341.7761535644531,409.88568115234375],[-335.7799987792969,405.8355407714844],[-328.8122253417969,400.9620361328125],[-322.85919189453125,396.69659423828125],[-316.864990234375,392.3641052246094],[-309.83441162109375,387.2817077636719],[-303.7019958496094,382.91656494140625],[-296.4871520996094,377.9043273925781],[-290.2275695800781,373.6203918457031],[-283.8898010253906,369.3025207519531],[-276.4451599121094,364.2795715332031],[-269.9974365234375,360.00518798828125],[-263.4903564453125,355.7406311035156],[-255.8247833251953,350.73828125],[-249.2130889892578,346.4259948730469],[-241.46841430664062,341.3741149902344],[-234.7635955810547,336.9996032714844],[-226.93643188476562,331.8918151855469],[-220.201171875,327.50164794921875],[-213.4136199951172,323.091552734375],[-205.46774291992188,317.94244384765625],[-198.61146545410156,313.507568359375],[-191.7333526611328,309.0702209472656],[-184.81216430664062,304.6393737792969],[-177.8411865234375,300.2414245605469],[-170.8166961669922,295.8592834472656],[-162.56796264648438,290.739990234375],[-155.4872283935547,286.3505554199219],[-147.20001220703125,281.2135009765625],[-140.06588745117188,276.7907409667969],[-132.8899383544922,272.3414001464844],[-124.5406494140625,267.1555480957031],[-117.33809661865234,262.63726806640625],[-108.97187805175781,257.3369140625],[-101.79790496826172,252.76919555664062],[-94.59222412109375,248.17510986328125],[-86.16791534423828,242.80172729492188],[-78.9188461303711,238.17724609375],[-70.4631576538086,232.78292846679688],[-63.166175842285156,228.1232147216797],[-55.87950897216797,223.46824645996094],[-47.367515563964844,218.04405212402344],[-40.02748489379883,213.38912963867188],[-31.450468063354492,207.97683715820312],[-24.07225227355957,203.3349609375],[-16.674636840820312,198.68487548828125],[-8.02165699005127,193.24468994140625],[-0.6182071566581726,188.5631103515625],[6.783617973327637,183.84564208984375],[14.197481155395508,179.09393310546875],[22.839962005615234,173.54302978515625],[30.269582748413086,168.7687225341797],[37.69920349121094,163.9939727783203],[45.16891860961914,159.19338989257812],[53.85313415527344,153.6111297607422],[61.309783935546875,148.81654357910156],[68.78099822998047,144.01123046875],[77.51546478271484,138.39169311523438]]

let point = [-540.5188598632812,362.7843322753906]
const zoom = 5;
let index = 0;

setInterval(function()
{
    point[0] = myData[index][0];
    point[1] = myData[index][1];
    
    if (index < myData.length)
        index++;
    else
        index = 0;
        
        console.log(index)
}, 100);

//-539.5188598632812,362.7843322753906
option = {
    grid:
    {
        width: '400px',
        height: '400px',
    },
    xAxis: {
        show: true,
        min: point[0]-zoom, max: point[0]+zoom,
        
        type: 'value',
    },
    yAxis: {
        show: true,
        min: point[1]-zoom, max: point[1]+zoom,
        type: 'value'
    },
    series: [{
        data: myData,
        symbol: 'none',
        type: 'line',
        smooth: true,
        lineStyle: {
            width: 1
        }
    }]
};

*/